webpackJsonp([3],{

/***/ 188:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__render__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_css__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Loading__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_toast__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_StarScore__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Map__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Footer__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DownloadBar__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_url__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_type__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_async__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_tripHelper__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_navigator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__store_actions_poi__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__store_actions_trip__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_clipboard__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_getPlatform__ = __webpack_require__(5);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * 入口：
 * * trip
 * * trip-map
 * * route
 *
 * * select-attraction
 * * search-attraction
 *
 * * edit-trip
 * * search-hotel
 */























// 头部渐隐渐现
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_getPlatform__["a" /* supportSdk */])() && zzc.call('base_setTopNavbarFadeIn', {
  startOffset: 140, // 开始呈现位置
  endOffset: 240, // 结束呈现位置
  success: function success(response) {}
});

// 左上角返回键样式
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_getPlatform__["a" /* supportSdk */])() && zzc.call('base_customNavbarLeftButton', {
  type: 'back_btn',
  imageUrl: 'back',
  topImageUrl: 'back_white',
  text: '返回'
});

var query = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_url__["a" /* getQuery */])();

var Poi = function (_React$Component) {
  _inherits(Poi, _React$Component);

  function Poi() {
    var _ref;

    var _temp, _this2, _ret;

    _classCallCheck(this, Poi);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = Poi.__proto__ || Object.getPrototypeOf(Poi)).call.apply(_ref, [this].concat(args))), _this2), _this2.handleNavigate = function () {
      var poi = _this2.props.poi;

      __WEBPACK_IMPORTED_MODULE_14__utils_navigator__["b" /* mapNavigation */](poi.data);
    }, _this2.handleClickMap = function () {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_url__["d" /* open */])('/m/v2/?m=render&page=poi-location', {
        poi_uid: query.poi_uid
      });
    }, _this2.handleClickBody = function () {
      _this2.clipboardMenu.isShow && _this2.clipboardMenu.hide();
    }, _this2.handleClickAddress = function (e) {
      e.stopPropagation();
      e.preventDefault();

      if (_this2.clipboardMenu.isShow) {
        _this2.clipboardMenu.hide();
      } else {
        var t = e.currentTarget;
        var top = t.offsetTop,
            width = t.clientWidth,
            left = t.offsetLeft + width / 2;

        var info = _this2.props.poi.data.info;
        var items = [];

        if (info.address) {
          items.push({
            name: '复制地址',
            key: 'address'
          });
        }

        if (info.lat && info.lng) {
          items.push({
            name: '复制经纬度',
            key: 'latlng'
          });
        }

        _this2.clipboardMenu.show({
          left: left, top: top, items: items
        });
      }
    }, _this2.clipboardMenu = function () {
      var el = document.createElement('div');
      el.className = 'bubble-menu';
      el.innerHTML = '';
      el.addEventListener('click', function () {
        controller.hide();
      });

      var style = document.createElement('style');
      style.innerHTML = '\n      .bubble-menu {\n        display: none; position: absolute; top: 0; left: 0;\n        white-space: nowrap; border-radius: .1rem;\n        font-size: 12px; color: #fff; background-color: rgba(0,0,0,.7);\n        transform: translate(-50%, -3em);\n      }\n      .bubble-menu::after {\n        content: \'\'; position: absolute; left: 50%; top: 100%;\n        width: 0; height: 0;\n        border-top: 8px solid rgba(0,0,0,.7);\n        border-left: 8px solid transparent;\n        border-right: 8px solid transparent;\n        transform: translate3d(-50%, 0, 0);\n      }\n      .bubble-menu span {\n        position: relative;\n        display: inline-block;\n        padding: 6px 2em;\n      }\n      .bubble-menu span::after {\n        content: \'|\';\n        position: absolute;\n        right: 0;\n      }\n      .bubble-menu span:last-child::after {\n        content: \'\';\n      }';
      document.body.appendChild(style);
      document.body.appendChild(el);

      var controller = {
        el: el,
        isShow: false,
        show: function show(params) {
          var left = params.left || 0;
          var top = params.top || 0;
          var items = params.items || [];

          var _html = '';
          items.forEach(function (item) {
            _html += '<span class="clipboard-trigger" data-key="' + item.key + '">' + item.name + '</span>';
          });

          el.innerHTML = _html;
          el.style.left = Math.round(left) + 'px';
          el.style.top = Math.round(top) + 'px';
          el.style.display = 'block';
          this.isShow = true;
        },
        hide: function hide() {
          el.style.display = 'none';
          this.isShow = false;
        }
      };

      return controller;
    }(), _temp), _possibleConstructorReturn(_this2, _ret);
  }

  _createClass(Poi, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          poi = _props.poi,
          trip = _props.trip,
          city = _props.city;


      if (__WEBPACK_IMPORTED_MODULE_12__utils_async__["c" /* isLoading */](poi.status)) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Loading__["c" /* LoadingScreen */], null);
      }

      if (__WEBPACK_IMPORTED_MODULE_12__utils_async__["d" /* isFailure */](poi.status)) {
        // TODO
      }

      poi = poi.data;
      if (!poi) return false;
      console.log(poi);

      var _poi$info = poi.info,
          pic = _poi$info.pic,
          cn_name = _poi$info.cn_name,
          en_name = _poi$info.en_name,
          grade = _poi$info.grade,
          address = _poi$info.address,
          lat = _poi$info.lat,
          lng = _poi$info.lng,
          tel = _poi$info.tel,
          open_time = _poi$info.open_time,
          desc = _poi$info.desc,
          average_prices = _poi$info.average_prices,
          tags = _poi$info.tags,
          stay_agv = _poi$info.stay_agv,
          wiki_url = _poi$info.wiki_url,
          good_desc = _poi$info.good_desc;


      tags instanceof Array || (tags = []);
      average_prices instanceof Array || (average_prices = []);

      // 处理整体页面高度不足的情况
      this.handleShortBodyHeight && this.handleShortBodyHeight();

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { id: 'poi',
          onClick: this.handleClickBody,
          onTouchMove: this.handleClickBody },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'main' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'section',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'banner' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'banner-entity', style: { backgroundImage: 'url(' + (pic.full || pic.big || pic.small_s) + ')' } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'main-info' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'primary-name' },
                cn_name
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'secondary-name' },
                en_name
              ),
              grade > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_StarScore__["a" /* default */], { score: grade }),
              !!good_desc && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'good-desc' },
                good_desc
              ),
              !!(tags.length || average_prices.length) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'tags-wrap' },
                !!tags.length && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'tags' },
                  tags.join('/')
                ),
                average_prices[0] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'price' },
                  '\u4EBA\u5747',
                  average_prices[0],
                  average_prices[1] && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'b',
                    null,
                    '(',
                    average_prices[1],
                    ')'
                  )
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'section',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'subfield address' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'left' },
                '\u5730\u5740'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'right' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { onClick: this.handleClickAddress },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'address',
                    null,
                    address
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'geolocation' },
                    latLngDecimalToStandard(lat, 'lat') + ', ' + latLngDecimalToStandard(lng, 'lng')
                  )
                ),
                !/create|edit|select-attraction/.test(__WEBPACK_IMPORTED_MODULE_11__utils_type__["b" /* TYPE */]) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { onClick: this.handleNavigate },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'icon icon-navigate' }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'b',
                    null,
                    '\u5BFC\u822A'
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Map__["a" /* default */], {
              poi: poi,
              onClick: this.handleClickMap }),
            open_time && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'subfield' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'left' },
                '\u8425\u4E1A'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'right' },
                open_time
              )
            ),
            poi.poi_type === 'attraction' && stay_agv && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'subfield' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'left' },
                '\u65F6\u957F'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'right' },
                '\u5EFA\u8BAE\u6E38\u73A9',
                __WEBPACK_IMPORTED_MODULE_13__utils_tripHelper__["n" /* getPoiTravelTime */](poi),
                '\u5C0F\u65F6'
              )
            ),
            tel && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'subfield' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'left' },
                '\u7535\u8BDD'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { href: 'tel:' + tel, className: 'tel' },
                tel
              )
            )
          ),
          !!(desc || wiki_url) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'section',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'subfield' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'left' },
                '\u7B80\u4ECB'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'desc-content' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: desc } }),
              wiki_url && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: 'wiki-entrance', href: wiki_url.url },
                '[\u7EF4\u57FA\u767E\u79D1]'
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Footer__["a" /* default */], {
          poi: poi,
          trip: trip,
          city: city }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__DownloadBar__["a" /* default */], null)
      );
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchPoi();
      this.fetchTrip();

      var _this = this;

      /**
       * 粘贴板工具初始化
       */
      var clipboard = new __WEBPACK_IMPORTED_MODULE_17_clipboard___default.a('.clipboard-trigger', {
        text: function text(trigger) {
          var dataKey = trigger.getAttribute('data-key');
          var result = ' ';
          var info = _this.props.poi.data.info;
          if (dataKey === 'latlng') {
            result = latLngDecimalToStandard(info.lat, 'lat') + ', ' + latLngDecimalToStandard(info.lng, 'lng');
          } else {
            result = info['address'];
          }
          return result;
        }
      });
      clipboard.on('success', function (e) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__components_toast__["a" /* default */])('复制成功');
      });
      clipboard.on('error', function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'handleShortBodyHeight',
    value: function handleShortBodyHeight() {
      this.handleShortBodyHeight = null;

      setTimeout(function () {
        // body高度不超过屏幕240以上的话，直接不显示
        if (document.body.scrollHeight - window.screen.height < 240) {
          console.log('bodyHeight not enough');
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__utils_getPlatform__["a" /* supportSdk */])() && zzc.call('base_setTopNavbarFadeIn', {
            startOffset: 300,
            endOffset: 300,
            success: function success(response) {}
          });
        }
      }, 10);
    }
  }, {
    key: 'isAttraction',
    value: function isAttraction() {
      var poi = this.props.poi;

      return __WEBPACK_IMPORTED_MODULE_13__utils_tripHelper__["i" /* type */].isAttraction(poi.data);
    }
  }, {
    key: 'fetchPoi',
    value: function fetchPoi() {
      var poi = this.props.poi;


      if (!poi.data) {
        __WEBPACK_IMPORTED_MODULE_15__store_actions_poi__["b" /* getPoi */](query.poi_uid, query.trip_id).catch(function (err) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__components_toast__["a" /* default */])(err.message);
        });
      }
    }
  }, {
    key: 'fetchTrip',
    value: function fetchTrip() {
      var trip = this.props.trip;


      if (query.trip_id && !trip) {
        __WEBPACK_IMPORTED_MODULE_16__store_actions_trip__["a" /* getTrip */](query.trip_id).catch(function (err) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__components_toast__["a" /* default */])(err.message);
        });
      }
    }
  }]);

  return Poi;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var PoiContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["a" /* connect */])(function (state) {
  var cityMap = state.entities.cities;
  var poiMap = state.entities.pois;
  var tripMap = state.entities.trips;
  var props = {
    poi: Object.assign({}, state.pages.poi)
  };

  var poi_uid = query.poi_uid;
  var poi = poiMap[query.poi_uid];

  // 收藏夹poi，自定义点除外，强制用线上数据，产品说详情少，数据丢失
  if (poi && poi.favorites_id && __WEBPACK_IMPORTED_MODULE_13__utils_tripHelper__["I" /* typeOfPoiUid */](poi_uid) !== 'custom_save') {
    poi = undefined;
  }

  // 优先使用缓存
  if (poi && cityMap[poi.info.city]) {
    props.poi = {
      status: 'success',
      message: '缓存',
      data: poi
    };
    props.city = cityMap[poi.info.city];
  } else if (props.poi.data) {
    props.poi.data = poiMap[poi_uid];

    var city = props.poi.data && props.poi.data.info && props.poi.data.info.city;
    props.city = cityMap[city];
  }

  var trip_id = query.trip_id;

  if (trip_id) {
    switch (__WEBPACK_IMPORTED_MODULE_11__utils_type__["b" /* TYPE */]) {
      case 'create':
        props.trip = state.editingTrip.start;
        break;
      case 'edit':
        props.trip = state.editingTrip.editTrip;
        break;
      case 'select-attraction':
        props.trip = state.editingTrip.selectAttraction;
        break;
      default:
        props.trip = tripMap[trip_id];
    }
  }

  return props;
})(Poi);

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__render__["a" /* default */])(PoiContainer);

function latLngDecimalToStandard(num, type) {
  num = Number(num) || 0;
  var s = type === 'lat' ? num >= 0 ? 'N' : 'S' : num >= 0 ? 'E' : 'W';
  num = Math.abs(num);
  var r1 = Math.floor(num);
  var r2 = Math.floor((num - r1) * 60);
  var r3 = ((num - r1 - r2 / 60) * 3600).toFixed(3);

  return r1 + '\xB0' + r2 + '\'' + r3 + '"' + s;
}

/***/ }),

/***/ 242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DownloadBar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_env__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DownloadBar_css__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DownloadBar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DownloadBar_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logo_png__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_url__ = __webpack_require__(1);







var query = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_url__["a" /* getQuery */])();
var CHANNEL = query.channel || '';

function DownloadBar(props) {
  if (__WEBPACK_IMPORTED_MODULE_1__utils_env__["IS_OUR_APP"]) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'download-bar' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'container' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'logo' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_3__logo_png___default.a, alt: 'logo' })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'slogan' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          null,
          '\u63A2\u9014\u65C5\u884C'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          '\u8F7B\u677E\u89C4\u5212\u884C\u7A0B\uFF0C\u63A2\u7D22\u4E16\u754C\u7F8E\u666F'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'btn' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { onClick: function onClick() {
              window.location.href = __WEBPACK_IMPORTED_MODULE_4__config__["downloadTanTuTravel"] + '?channel=' + CHANNEL + '&from=poi';
            } },
          '\u4E0B \u8F7D'
        )
      )
    )
  );
}

/***/ }),

/***/ 243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_actions_trip__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_tripHelper__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_url__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_navigator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Loading__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_toast__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_compatible__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_type__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Footer_css__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Footer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Footer_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var query = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_url__["a" /* getQuery */])();

var Footer = function (_React$Component) {
  _inherits(Footer, _React$Component);

  function Footer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Footer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Footer.__proto__ || Object.getPrototypeOf(Footer)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
      var _this$props = _this.props,
          poi = _this$props.poi,
          trip = _this$props.trip,
          city = _this$props.city;

      var day = parseInt(query.day, 10);
      var step = query.step ? parseInt(query.step, 10) : 1;

      if (_this.isAdded()) {
        trip = __WEBPACK_IMPORTED_MODULE_2__utils_tripHelper__["E" /* deletePoi */](trip, poi.poi_uid, __WEBPACK_IMPORTED_MODULE_2__utils_tripHelper__["i" /* type */].isHotel(poi) ? query.day : false);
      } else {

        var checkResult = __WEBPACK_IMPORTED_MODULE_2__utils_tripHelper__["F" /* checkAddPoi */](trip, poi, day);
        if (checkResult !== true) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__components_toast__["a" /* default */])(checkResult.message);
        }

        trip = __WEBPACK_IMPORTED_MODULE_2__utils_tripHelper__["G" /* addPoi */](trip, poi, day, city);
      }

      switch (__WEBPACK_IMPORTED_MODULE_8__utils_type__["b" /* TYPE */]) {
        case 'create':
          __WEBPACK_IMPORTED_MODULE_1__store_actions_trip__["d" /* editTrip */](trip, __WEBPACK_IMPORTED_MODULE_1__store_actions_trip__["d" /* editTrip */].targets[0]);
          __WEBPACK_IMPORTED_MODULE_4__utils_navigator__["g" /* back */](-step);
          break;
        case 'edit':
          __WEBPACK_IMPORTED_MODULE_1__store_actions_trip__["d" /* editTrip */](trip, __WEBPACK_IMPORTED_MODULE_1__store_actions_trip__["d" /* editTrip */].targets[1]);
          __WEBPACK_IMPORTED_MODULE_4__utils_navigator__["g" /* back */](-step);
          break;
        case 'select-attraction':
          __WEBPACK_IMPORTED_MODULE_1__store_actions_trip__["d" /* editTrip */](trip, __WEBPACK_IMPORTED_MODULE_1__store_actions_trip__["d" /* editTrip */].targets[2]);
          __WEBPACK_IMPORTED_MODULE_4__utils_navigator__["g" /* back */](-step);
          break;
        default:
          var hide = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__components_Loading__["a" /* show */])();
          __WEBPACK_IMPORTED_MODULE_1__store_actions_trip__["e" /* asyncSaveTrip */](trip.trip_id, trip).then(function () {
            hide();
            __WEBPACK_IMPORTED_MODULE_4__utils_navigator__["g" /* back */](-step);
          }).catch(function (err) {
            hide();
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__components_toast__["a" /* default */])(err.message);
          });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Footer, [{
    key: 'isAdded',
    value: function isAdded() {
      var _props = this.props,
          poi = _props.poi,
          trip = _props.trip;

      // 多天可以添加同一酒店，判断酒店是否已添加时，要加当前天参数，非酒店时不加

      if (__WEBPACK_IMPORTED_MODULE_2__utils_tripHelper__["i" /* type */].isHotel(poi)) {
        return __WEBPACK_IMPORTED_MODULE_2__utils_tripHelper__["N" /* existPoi */](trip, poi.poi_uid, query.day);
      } else {
        return __WEBPACK_IMPORTED_MODULE_2__utils_tripHelper__["N" /* existPoi */](trip, poi.poi_uid);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          poi = _props2.poi,
          trip = _props2.trip;


      if (!trip || __WEBPACK_IMPORTED_MODULE_8__utils_type__["a" /* isPreview */]) {
        return null;
      }

      var isAdded = this.isAdded();

      // 不是酒店，且已添加，则不出现删除按钮。
      if (!__WEBPACK_IMPORTED_MODULE_2__utils_tripHelper__["i" /* type */].isHotel(poi) && isAdded) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'footer',
        {
          className: 'footer',
          onClick: this.handleClick },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'icon icon-add' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'add-to-trip-btn' },
          isAdded ? '已' : '',
          '\u52A0\u5165\u884C\u7A0B'
        )
      );
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var poi = this.props.poi;


      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_compatible__["a" /* setTitle */])(poi.info.cn_name);
    }
  }]);

  return Footer;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Footer);

/***/ }),

/***/ 244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Map;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Map__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Map_css__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Map_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Map_css__);




function Map(props) {
  var poi = props.poi;

  var info = poi.info;

  var marker = {
    type: 'locateMarker',
    className: 'locate',
    size: {
      width: '0.8rem',
      height: '0.8rem'
    },
    latLng: [info.lat, info.lng]
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'map-wrap' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_Map__["a" /* default */], { markers: [marker], maxZoom: 13 }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'map-mask', onClick: props.onClick })
  );
}

/***/ }),

/***/ 321:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(576)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require('select'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.select);
        global.clipboardAction = mod.exports;
    }
})(this, function (module, _select) {
    'use strict';

    var _select2 = _interopRequireDefault(_select);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    var ClipboardAction = function () {
        /**
         * @param {Object} options
         */
        function ClipboardAction(options) {
            _classCallCheck(this, ClipboardAction);

            this.resolveOptions(options);
            this.initSelection();
        }

        /**
         * Defines base properties passed from constructor.
         * @param {Object} options
         */


        _createClass(ClipboardAction, [{
            key: 'resolveOptions',
            value: function resolveOptions() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                this.action = options.action;
                this.container = options.container;
                this.emitter = options.emitter;
                this.target = options.target;
                this.text = options.text;
                this.trigger = options.trigger;

                this.selectedText = '';
            }
        }, {
            key: 'initSelection',
            value: function initSelection() {
                if (this.text) {
                    this.selectFake();
                } else if (this.target) {
                    this.selectTarget();
                }
            }
        }, {
            key: 'selectFake',
            value: function selectFake() {
                var _this = this;

                var isRTL = document.documentElement.getAttribute('dir') == 'rtl';

                this.removeFake();

                this.fakeHandlerCallback = function () {
                    return _this.removeFake();
                };
                this.fakeHandler = this.container.addEventListener('click', this.fakeHandlerCallback) || true;

                this.fakeElem = document.createElement('textarea');
                // Prevent zooming on iOS
                this.fakeElem.style.fontSize = '12pt';
                // Reset box model
                this.fakeElem.style.border = '0';
                this.fakeElem.style.padding = '0';
                this.fakeElem.style.margin = '0';
                // Move element out of screen horizontally
                this.fakeElem.style.position = 'absolute';
                this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';
                // Move element to the same position vertically
                var yPosition = window.pageYOffset || document.documentElement.scrollTop;
                this.fakeElem.style.top = yPosition + 'px';

                this.fakeElem.setAttribute('readonly', '');
                this.fakeElem.value = this.text;

                this.container.appendChild(this.fakeElem);

                this.selectedText = (0, _select2.default)(this.fakeElem);
                this.copyText();
            }
        }, {
            key: 'removeFake',
            value: function removeFake() {
                if (this.fakeHandler) {
                    this.container.removeEventListener('click', this.fakeHandlerCallback);
                    this.fakeHandler = null;
                    this.fakeHandlerCallback = null;
                }

                if (this.fakeElem) {
                    this.container.removeChild(this.fakeElem);
                    this.fakeElem = null;
                }
            }
        }, {
            key: 'selectTarget',
            value: function selectTarget() {
                this.selectedText = (0, _select2.default)(this.target);
                this.copyText();
            }
        }, {
            key: 'copyText',
            value: function copyText() {
                var succeeded = void 0;

                try {
                    succeeded = document.execCommand(this.action);
                } catch (err) {
                    succeeded = false;
                }

                this.handleResult(succeeded);
            }
        }, {
            key: 'handleResult',
            value: function handleResult(succeeded) {
                this.emitter.emit(succeeded ? 'success' : 'error', {
                    action: this.action,
                    text: this.selectedText,
                    trigger: this.trigger,
                    clearSelection: this.clearSelection.bind(this)
                });
            }
        }, {
            key: 'clearSelection',
            value: function clearSelection() {
                if (this.trigger) {
                    this.trigger.focus();
                }

                window.getSelection().removeAllRanges();
            }
        }, {
            key: 'destroy',
            value: function destroy() {
                this.removeFake();
            }
        }, {
            key: 'action',
            set: function set() {
                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';

                this._action = action;

                if (this._action !== 'copy' && this._action !== 'cut') {
                    throw new Error('Invalid "action" value, use either "copy" or "cut"');
                }
            },
            get: function get() {
                return this._action;
            }
        }, {
            key: 'target',
            set: function set(target) {
                if (target !== undefined) {
                    if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && target.nodeType === 1) {
                        if (this.action === 'copy' && target.hasAttribute('disabled')) {
                            throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                        }

                        if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
                            throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                        }

                        this._target = target;
                    } else {
                        throw new Error('Invalid "target" value, use a valid Element');
                    }
                }
            },
            get: function get() {
                return this._target;
            }
        }]);

        return ClipboardAction;
    }();

    module.exports = ClipboardAction;
});

/***/ }),

/***/ 322:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(321), __webpack_require__(581), __webpack_require__(440)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require('./clipboard-action'), require('tiny-emitter'), require('good-listener'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.clipboardAction, global.tinyEmitter, global.goodListener);
        global.clipboard = mod.exports;
    }
})(this, function (module, _clipboardAction, _tinyEmitter, _goodListener) {
    'use strict';

    var _clipboardAction2 = _interopRequireDefault(_clipboardAction);

    var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);

    var _goodListener2 = _interopRequireDefault(_goodListener);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    function _possibleConstructorReturn(self, call) {
        if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var Clipboard = function (_Emitter) {
        _inherits(Clipboard, _Emitter);

        /**
         * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
         * @param {Object} options
         */
        function Clipboard(trigger, options) {
            _classCallCheck(this, Clipboard);

            var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this));

            _this.resolveOptions(options);
            _this.listenClick(trigger);
            return _this;
        }

        /**
         * Defines if attributes would be resolved using internal setter functions
         * or custom functions that were passed in the constructor.
         * @param {Object} options
         */


        _createClass(Clipboard, [{
            key: 'resolveOptions',
            value: function resolveOptions() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
                this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
                this.text = typeof options.text === 'function' ? options.text : this.defaultText;
                this.container = _typeof(options.container) === 'object' ? options.container : document.body;
            }
        }, {
            key: 'listenClick',
            value: function listenClick(trigger) {
                var _this2 = this;

                this.listener = (0, _goodListener2.default)(trigger, 'click', function (e) {
                    return _this2.onClick(e);
                });
            }
        }, {
            key: 'onClick',
            value: function onClick(e) {
                var trigger = e.delegateTarget || e.currentTarget;

                if (this.clipboardAction) {
                    this.clipboardAction = null;
                }

                this.clipboardAction = new _clipboardAction2.default({
                    action: this.action(trigger),
                    target: this.target(trigger),
                    text: this.text(trigger),
                    container: this.container,
                    trigger: trigger,
                    emitter: this
                });
            }
        }, {
            key: 'defaultAction',
            value: function defaultAction(trigger) {
                return getAttributeValue('action', trigger);
            }
        }, {
            key: 'defaultTarget',
            value: function defaultTarget(trigger) {
                var selector = getAttributeValue('target', trigger);

                if (selector) {
                    return document.querySelector(selector);
                }
            }
        }, {
            key: 'defaultText',
            value: function defaultText(trigger) {
                return getAttributeValue('text', trigger);
            }
        }, {
            key: 'destroy',
            value: function destroy() {
                this.listener.destroy();

                if (this.clipboardAction) {
                    this.clipboardAction.destroy();
                    this.clipboardAction = null;
                }
            }
        }], [{
            key: 'isSupported',
            value: function isSupported() {
                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];

                var actions = typeof action === 'string' ? [action] : action;
                var support = !!document.queryCommandSupported;

                actions.forEach(function (action) {
                    support = support && !!document.queryCommandSupported(action);
                });

                return support;
            }
        }]);

        return Clipboard;
    }(_tinyEmitter2.default);

    /**
     * Helper function to retrieve attribute value.
     * @param {String} suffix
     * @param {Element} element
     */
    function getAttributeValue(suffix, element) {
        var attribute = 'data-clipboard-' + suffix;

        if (!element.hasAttribute(attribute)) {
            return;
        }

        return element.getAttribute(attribute);
    }

    module.exports = Clipboard;
});

/***/ }),

/***/ 325:
/***/ (function(module, exports) {

var DOCUMENT_NODE_TYPE = 9;

/**
 * A polyfill for Element.matches()
 */
if (typeof Element !== 'undefined' && !Element.prototype.matches) {
    var proto = Element.prototype;

    proto.matches = proto.matchesSelector ||
                    proto.mozMatchesSelector ||
                    proto.msMatchesSelector ||
                    proto.oMatchesSelector ||
                    proto.webkitMatchesSelector;
}

/**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */
function closest (element, selector) {
    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
        if (typeof element.matches === 'function' &&
            element.matches(selector)) {
          return element;
        }
        element = element.parentNode;
    }
}

module.exports = closest;


/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

var closest = __webpack_require__(325);

/**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function _delegate(element, selector, type, callback, useCapture) {
    var listenerFn = listener.apply(this, arguments);

    element.addEventListener(type, listenerFn, useCapture);

    return {
        destroy: function() {
            element.removeEventListener(type, listenerFn, useCapture);
        }
    }
}

/**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function delegate(elements, selector, type, callback, useCapture) {
    // Handle the regular Element usage
    if (typeof elements.addEventListener === 'function') {
        return _delegate.apply(null, arguments);
    }

    // Handle Element-less usage, it defaults to global delegation
    if (typeof type === 'function') {
        // Use `document` as the first parameter, then apply arguments
        // This is a short way to .unshift `arguments` without running into deoptimizations
        return _delegate.bind(null, document).apply(null, arguments);
    }

    // Handle Selector-based usage
    if (typeof elements === 'string') {
        elements = document.querySelectorAll(elements);
    }

    // Handle Array-like based usage
    return Array.prototype.map.call(elements, function (element) {
        return _delegate(element, selector, type, callback, useCapture);
    });
}

/**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */
function listener(element, selector, type, callback) {
    return function(e) {
        e.delegateTarget = closest(e.target, selector);

        if (e.delegateTarget) {
            callback.call(element, e);
        }
    }
}

module.exports = delegate;


/***/ }),

/***/ 374:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 375:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 376:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 377:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 439:
/***/ (function(module, exports) {

/**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.node = function(value) {
    return value !== undefined
        && value instanceof HTMLElement
        && value.nodeType === 1;
};

/**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.nodeList = function(value) {
    var type = Object.prototype.toString.call(value);

    return value !== undefined
        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
        && ('length' in value)
        && (value.length === 0 || exports.node(value[0]));
};

/**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.string = function(value) {
    return typeof value === 'string'
        || value instanceof String;
};

/**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.fn = function(value) {
    var type = Object.prototype.toString.call(value);

    return type === '[object Function]';
};


/***/ }),

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {

var is = __webpack_require__(439);
var delegate = __webpack_require__(326);

/**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listen(target, type, callback) {
    if (!target && !type && !callback) {
        throw new Error('Missing required arguments');
    }

    if (!is.string(type)) {
        throw new TypeError('Second argument must be a String');
    }

    if (!is.fn(callback)) {
        throw new TypeError('Third argument must be a Function');
    }

    if (is.node(target)) {
        return listenNode(target, type, callback);
    }
    else if (is.nodeList(target)) {
        return listenNodeList(target, type, callback);
    }
    else if (is.string(target)) {
        return listenSelector(target, type, callback);
    }
    else {
        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
    }
}

/**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNode(node, type, callback) {
    node.addEventListener(type, callback);

    return {
        destroy: function() {
            node.removeEventListener(type, callback);
        }
    }
}

/**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNodeList(nodeList, type, callback) {
    Array.prototype.forEach.call(nodeList, function(node) {
        node.addEventListener(type, callback);
    });

    return {
        destroy: function() {
            Array.prototype.forEach.call(nodeList, function(node) {
                node.removeEventListener(type, callback);
            });
        }
    }
}

/**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenSelector(selector, type, callback) {
    return delegate(document.body, selector, type, callback);
}

module.exports = listen;


/***/ }),

/***/ 576:
/***/ (function(module, exports) {

function select(element) {
    var selectedText;

    if (element.nodeName === 'SELECT') {
        element.focus();

        selectedText = element.value;
    }
    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
        var isReadOnly = element.hasAttribute('readonly');

        if (!isReadOnly) {
            element.setAttribute('readonly', '');
        }

        element.select();
        element.setSelectionRange(0, element.value.length);

        if (!isReadOnly) {
            element.removeAttribute('readonly');
        }

        selectedText = element.value;
    }
    else {
        if (element.hasAttribute('contenteditable')) {
            element.focus();
        }

        var selection = window.getSelection();
        var range = document.createRange();

        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);

        selectedText = selection.toString();
    }

    return selectedText;
}

module.exports = select;


/***/ }),

/***/ 581:
/***/ (function(module, exports) {

function E () {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
  on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    function listener () {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    };

    listener._ = callback
    return this.on(name, listener, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;
module.exports.TinyEmitter = E;


/***/ }),

/***/ 588:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 603:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(188);


/***/ })

},[603]);


// WEBPACK FOOTER //
// static/js/poi2.2e1bfe69.js